import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiUploadedFile, NewUploadedFile, Profile } from '../segment-files-section.model';
import { Result } from '@/reservation/reservation.model';

@Injectable({
	providedIn: 'root',
})
export class SegmentFilesApiService {
	private readonly httpClient = inject(HttpClient);

	getSegmentFiles(segmentId: number): Observable<ApiUploadedFile[]> {
		return this.httpClient
			.get<Result<ApiUploadedFile>>(`${environment.apiUrl}/transport/segments/${segmentId}/files/`)
			.pipe(map((result) => result?.results));
	}

	getProfile(): Observable<Profile> {
		return this.httpClient.get<Profile>(`${environment.apiUrl}/profile/`);
	}

	createSegmentFile(segmentId: number, file: NewUploadedFile): Observable<ApiUploadedFile> {
		const formData = new FormData();
		formData.append('file', file.file);
		formData.append('note', file.note);
		formData.append('externalUrl', file.externalUrl);

		return this.httpClient.post<ApiUploadedFile>(
			`${environment.apiUrl}/transport/segments/${segmentId}/files/`,
			formData,
		);
	}

	deleteSegmentFile(segmentId: number, fileId: number): Observable<void> {
		return this.httpClient.delete<void>(`${environment.apiUrl}/transport/segments/${segmentId}/files/${fileId}/`);
	}
}
